/*
 * @Author: your name
 * @Date: 2020-12-07 18:02:15
 * @LastEditTime: 2020-12-09 20:37:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shopManagement/src/service/basic/exceptionApiList.js
 */
const noticeApiList = {
  getNotice: "/system/notice/duanglist", // 获取未读消息列表
  getDetail: "/system/notice/duangdetail", //消息详情
  confirmNotice: "/system/notice/confirm" //确认消息
};
export default noticeApiList;



// WEBPACK FOOTER //
// ./src/service/basic/noticeApiList.js